import { ITestTrack } from 'interfaces'

type PaperRequestNameInput = {
  test_track_id: string
  paper_template_id: string
}

type ExistingPaperRequest = {
  test_track_id?: string
}

const getSetLetter = (setIndex: number): string => {
  if (setIndex < 26) {
    return String.fromCharCode(65 + setIndex)
  }
  return `Z${setIndex - 25}`
}

export const buildPaperRequestName = (
  paperRequest: PaperRequestNameInput,
  testTracks: ITestTrack[],
  existingRequestsForEvent: ExistingPaperRequest[],
  batchCountByTrack: Map<string, number>,
  productType: string,
  date: Date = new Date()
): string => {
  const testTrackId = paperRequest.test_track_id
  const testTrackName = testTracks.find(track => track?.id === testTrackId)?.name ?? 'Unknown Track'
  const year = date.getFullYear()
  const monthName = date.toLocaleString('default', { month: 'short' })

  const existingCountForTrack = existingRequestsForEvent.filter(request => request.test_track_id === testTrackId).length
  const batchOffset = batchCountByTrack.get(testTrackId) ?? 0
  batchCountByTrack.set(testTrackId, batchOffset + 1)

  const setLetter = getSetLetter(existingCountForTrack + batchOffset)
  const templateSuffix = paperRequest.paper_template_id?.slice(-4) ?? '0000'

  return `${testTrackName}-${productType.toUpperCase()}-Set ${setLetter}-${monthName}_${year}_${templateSuffix}${batchOffset}`
}

export const buildPaperRequestNames = (
  paperRequests: PaperRequestNameInput[],
  testTracks: ITestTrack[],
  existingRequestsForEvent: ExistingPaperRequest[],
  productType: string,
  date: Date = new Date()
): string[] => {
  const batchCountByTrack = new Map<string, number>()

  return paperRequests.map(paperRequest =>
    buildPaperRequestName(paperRequest, testTracks, existingRequestsForEvent, batchCountByTrack, productType, date)
  )
}
